import { createContext, useCallback, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { track, EVENTS } from "@/lib/analytics";

const EnquiryContext = createContext(null);

const PAGES_WITH_FORM = ["/", "/contact"];

export const EnquiryProvider = ({ children }) => {
  const [prefill, setPrefill] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const openEnquiry = useCallback(
    ({ product = "", grade = "", enquiryType = "Quotation", source = "" } = {}) => {
      setPrefill({ product, grade, enquiryType, key: Date.now() });
      track(enquiryType === "Actual-Lot Sample" ? EVENTS.sampleRequestClick : EVENTS.requestQuoteClick, {
        product: product || "unspecified",
        source: source || location.pathname,
      });
      if (PAGES_WITH_FORM.includes(location.pathname)) {
        document.getElementById("enquiry-form-anchor")?.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        navigate("/contact#enquiry-form-anchor");
      }
    },
    [location.pathname, navigate]
  );

  const clearPrefill = useCallback(() => setPrefill(null), []);

  return (
    <EnquiryContext.Provider value={{ prefill, openEnquiry, clearPrefill }}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => {
  const ctx = useContext(EnquiryContext);
  if (!ctx) throw new Error("useEnquiry must be used inside EnquiryProvider");
  return ctx;
};
